import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\src\\app\\news\\page.js");
